import { http } from '@/services/http_service';
export default {
    fetchGoods(context)
    {
        return http()
        .post("/goods/fetchGoods")
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)           

            context.commit('setGoods', response.data)

            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    goodsView(context,data)
    {
        return http()
        .post("/goods/goodsView",data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)

            context.commit('setGoodsView', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    goodsBuy(context, data)
    {
        return http()
        .post("/goods/goodsBuy",data)//itemId, user_id, user_name, bank_name, bank_num
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log(response)
            //context.commit('setItemView', response.data)
            return response.data;
        },function(error){
            //console.log(error.response.data)
            return error.response.data;
        });
    },
    //구매내역
    getBuyGoods(context,data)
    {
        return http()
        .post("/goods/goodsBuyList?page="+data.page,data)//user_id
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //context.commit('setItemView', response.data)
            context.commit('setGoodsBuy', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
   
    //환불신청 및 구매 취소
    reqRefund(context,data)
    {
        return http()
        .post("/goods/reqRefund",data)//itemBuyId, count
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log('환불신청',response.data)
            //context.commit('setItemView', response.data)
            context.commit('updateGoodsBuy', response.data.goodsBuy)
            return response.data;
        },function(error){
            console.log(error.response.data)
            return error.response.data;
        });
    },
     //카운터 값 가져오기
     getCount()
     {
         return http()
         .post("/goods/getCount")//user_id
         .then((response) => {           
            return response.data;
         },function(error){
            console.log(error.response.data)
            return error.response.data;
         });
     },
}
